import { render, staticRenderFns } from "./AddAlarm.vue?vue&type=template&id=a6d273b2&scoped=true&"
import script from "./AddAlarm.vue?vue&type=script&lang=js&"
export * from "./AddAlarm.vue?vue&type=script&lang=js&"
import style0 from "./AddAlarm.vue?vue&type=style&index=0&id=a6d273b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d273b2",
  null
  
)

export default component.exports